import { frontendURL } from '../../../../helper/URLHelper';

const campaigns = accountId => ({
  parentNav: 'campaigns',
  routes: [
    'settings_account_campaigns',
    'one_off',
    'add_campaign',
    'email_templates',
    'email_template_add',
    'email_template_edit',
    'ai_broadcast_list',
    'ai_broadcast_add',
    'campaign_form_list',
    'campaign_form_add',
    'campaign_form_edit',
    'campaign_form_responder_list',
    'outbound_call_campaigns',
    'add_outbound_call_campaign',
    'edit_outbound_call_campaign',
    'outbound_call_campaign_details',
  ],
  menuItems: [
    {
      key: 'oneOffCampaigns',
      icon: 'sound-source',
      label: 'ONE_OFF',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/one_off`),
      toStateName: 'one_off',
    },
    {
      key: 'emailTemplates',
      icon: 'sound-source',
      label: 'EMAIL_TEMPLATES',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/email_templates`),
      toStateName: 'email_templates',
    },
    {
      key: 'campaignForms',
      icon: 'document',
      label: 'CAMPAIGN_FORMS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/forms`),
      toStateName: 'campaign_form_list',
    },
    {
      key: 'outboundCallCampaign',
      icon: 'call-outbound',
      label: 'OUTBOUND_CALL_CAMPAIGNS',
      hasSubMenu: false,
      toState: frontendURL(
        `accounts/${accountId}/campaigns/outbound-call-campaigns`
      ),
      toStateName: 'outbound_call_campaigns',
    },
    {
      key: 'aiBroadcastList',
      icon: 'call',
      label: 'AI_BROADCAST',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/aiBroadcast`),
      toStateName: 'ai_broadcast_list',
    },
    {
      key: 'evaluationReports',
      icon: 'document-bullet',
      label: 'EVALUATIONS_REPORTS',
      hasSubMenu: false,
      toState: frontendURL(
        `accounts/${accountId}/campaigns/evaluations/reports`
      ),
      toStateName: 'evaluation_report',
    },
  ],
});

export default campaigns;
